import { FC } from 'react';
import { Grid, MenuItem } from '@mui/material';
import { FilterList, Close } from '@mui/icons-material';
import { SMBSelect, SearchField, Button as SMButton, FiltersLayout } from '../../../components';
import { SalesNeighborhoodAutoComplete } from '../../../components/dropdowns/sales-neighborhood-autocomplete';
import { SalesTerritoryAutoComplete } from '../../../components/dropdowns/territory-autocomplete';

interface ISalesManagementFilters {
  isLoadingAddressBook: boolean;
  nameSearch: string;
  setNameSearch: (value: string) => void;
  isGlobal: string | null;
  setIsGlobal: (value: string | null) => void;
  selectedNeighborhoods: number[];
  setSelectedNeighborhoods: (value: number[]) => void;
  selectedTerritories: number[];
  setSelectedTerritories: (value: number[]) => void;
  handleApplyFilters: () => void;
  handleClearFilters: () => void;
  hasAppliedFilters: boolean;
}

export const SalesManagementFilters: FC<ISalesManagementFilters> = ({
  isLoadingAddressBook,
  nameSearch,
  setNameSearch,
  isGlobal,
  setIsGlobal,
  selectedNeighborhoods,
  setSelectedNeighborhoods,
  selectedTerritories,
  setSelectedTerritories,
  handleApplyFilters,
  handleClearFilters,
  hasAppliedFilters,
}) => {
  const handleIsGlobalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsGlobal(
      event.target.value === 'true' ? 'true' : event.target.value === 'false' ? 'false' : null
    );
  };

  return (
    <FiltersLayout alignItems="flex-start">
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <SearchField
          isDisabled={isLoadingAddressBook}
          placeholder="Name"
          handleSearch={handleApplyFilters}
          handleClearSearch={() => {
            setNameSearch('');
          }}
          searchValue={nameSearch}
          setSearchValue={setNameSearch}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <SMBSelect
          label="All Address Books"
          value={isGlobal}
          onChange={handleIsGlobalChange}
          handleClear={() => setIsGlobal(null)}
        >
          <MenuItem value="true">Yes</MenuItem>
          <MenuItem value="false">No</MenuItem>
        </SMBSelect>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <SalesTerritoryAutoComplete
          limitTags={4}
          multiple={true}
          value={selectedTerritories}
          handleChange={setSelectedTerritories}
          handleClear={() => {
            setSelectedTerritories([]);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <SalesNeighborhoodAutoComplete
          limitTags={4}
          value={selectedNeighborhoods}
          handleChange={setSelectedNeighborhoods}
          handleClear={() => {
            setSelectedNeighborhoods([]);
          }}
          apiParams={{ IsActive: true }}
        />
      </Grid>
      <Grid item xs={12}>
        <SMButton
          id="apply-filters"
          onClick={handleApplyFilters}
          startIcon={<FilterList />}
          color="primary"
          variant="contained"
        >
          Apply Filters
        </SMButton>
        {hasAppliedFilters && (
          <SMButton
            id="clear-filters"
            onClick={handleClearFilters}
            type="button"
            variant="contained"
            color="inherit"
            startIcon={<Close />}
          >
            Reset
          </SMButton>
        )}
      </Grid>
    </FiltersLayout>
  );
};